module.exports = __webpack_public_path__ + "img/shop_small_333.61904cb3.svg";